/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:b9a8e049-987b-4120-a348-713b22ac9a60",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_jpI58sFcN",
    "aws_user_pools_web_client_id": "1mrvddbhhc6tta6pe72u4c1ssq",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "betplus-user-infof143e-dev",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
